import { render, staticRenderFns } from "./InventoryManageCustom.vue?vue&type=template&id=233d6428&scoped=true&"
import script from "./InventoryManageCustom.vue?vue&type=script&lang=js&"
export * from "./InventoryManageCustom.vue?vue&type=script&lang=js&"
import style0 from "./InventoryManageCustom.vue?vue&type=style&index=0&id=233d6428&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "233d6428",
  null
  
)

export default component.exports